import { View, Text } from "react-native";
import { styles } from "../styles/mainStyle";
import { Image, Button } from "@rneui/base";
import React from "react";
import { ScrollView } from "react-native-web";

const ThankYou = ({ navigation, route }) => {
  console.log(route.params);
  return (
    <ScrollView>
      <Text style={styles.h1checkout}>Gracias Por su Compra</Text>
      <View style={styles.flexBoxCenter}>
        <Text style={styles.sectionTitle}>
          Nos pondremos en contacto contigo!
        </Text>
        {route.params.pago == "Transferencia bancaria/deposito" && (
          <>
            <Image
              source={require("../assets/cuenta.png")}
              style={{
                width: 800,
                height: 559,
                resizeMode: "contain",
              }}
            />
            <Image
              source={require("../assets/cuenta-drn.png")}
              style={{
                width: 800,
                height: 559,
                resizeMode: "contain",
              }}
            />
          </>
        )}

        <Text style={styles.total}>
          SubTotal: ${(route.params.total * 1).toFixed(2)}
        </Text>
        {route.params.discount > 0 && (
          <Text style={styles.total}>
            Descuento: ${(route.params.discount * 1).toFixed(2)}
          </Text>
        )}

        <Text style={styles.totalFinal}>
          Total: ${(route.params.total - route.params.discount).toFixed(2)} +
          IVA
        </Text>
        <Button
          title="Volver a la tienda"
          buttonStyle={styles.buttonAlt}
          titleStyle={styles.btnTitleAlt}
          onPress={() => navigation.navigate("Home")}
        />
      </View>
    </ScrollView>
  );
};

export default ThankYou;
